import { render, staticRenderFns } from "./OldMatterForm.vue?vue&type=template&id=3e499aa3&scoped=true"
import script from "./OldMatterForm.vue?vue&type=script&lang=js"
export * from "./OldMatterForm.vue?vue&type=script&lang=js"
import style0 from "./OldMatterForm.vue?vue&type=style&index=0&id=3e499aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e499aa3",
  null
  
)

export default component.exports